import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

declare function decrypt(input): any
declare function encrypt(input): any
enum EncryptMode {
    e = "encrypt",
    d = "decrypt"
}

@Injectable({
    providedIn: 'root'
})

export class EncryptDecryptService {
    // private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    // private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
    // constructor(private toastr: ToastrService) { }
    // // Methods for the encrypt and decrypt Using AES
    // encryptUsingAES256(text): any {
    //    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this.key, {
    //        keySize: 128 / 8,
    //        iv: this.iv,
    //        mode: CryptoJS.mode.CBC,
    //        padding: CryptoJS.pad.Pkcs7
    //    });
    //    return encrypted.toString();
    // }


    // decryptUsingAES256(decString) {
    //    var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
    //        keySize: 128 / 8,
    //        iv: this.iv,
    //        mode: CryptoJS.mode.CBC,
    //        padding: CryptoJS.pad.Pkcs7
    //    });
    //    return decrypted.toString(CryptoJS.enc.Utf8);
    // }

//method for encrypt and decrypt wasm
    public async decryptEncrpyt(input, mode: EncryptMode) {
        //Now that we use this method in the jwt interceptor, it is used quite early
        //which means that sometimes, the function is not yet loaded before we call it

        const waitForWASMFunctionsToLoad = async () => {
            let i = 0;
            //we keep checking that the method exists for up to 2 seconds
            while (typeof encrypt === 'undefined' || typeof decrypt === 'undefined') {
                if (i >= 20) {
                    throw new Error('encrypt/decrypt load error');
                    break;
                }

                console.log('waiting for encrypt/decrypt WASM functions to load');
                await new Promise((resolve) => setTimeout(resolve, 100));

                i++;
            }
        }

        if (mode == EncryptMode.e) {
            await waitForWASMFunctionsToLoad();
            return encrypt(input);
        }
        else if (mode == EncryptMode.d) {
            await waitForWASMFunctionsToLoad();
            return decrypt(input);
        }
        else {
            const error = "encrypt/decrypt error. Invalid EncryptMode"
            //this.toastr.error(error);
            throw error;
        }

        
    }

}
